import { reactive } from "vue";

// Cada cuánto se comprueba si hay una versión nueva con la pestaña visible
export const CHECK_INTERVAL_MS = 10 * 60 * 1000;

export const versionState = reactive({
  updateAvailable: false,
  serverVersion: null,
  dismissedVersion: null,
});

// Identificador de esta compilación (lo inyecta vue.config.js); vacío fuera de un build
const currentVersion = () => process.env.VUE_APP_BUILD_ID;

export async function checkForNewVersion(fetchFn = fetch) {
  const current = currentVersion();
  if (!current) return false;
  try {
    // version.json se publica junto al front: nunca se sirve de caché
    const response = await fetchFn(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    if (!response.ok) return false;
    const serverVersion = (await response.json())?.version;
    if (typeof serverVersion !== "string" || !serverVersion) return false;

    versionState.serverVersion = serverVersion;
    versionState.updateAvailable = serverVersion !== current && serverVersion !== versionState.dismissedVersion;
  } catch {
    // Sin red o respuesta inesperada: se vuelve a intentar en la siguiente comprobación
    return false;
  }
  return versionState.updateAvailable;
}

// "Más tarde": el aviso solo vuelve a salir si se despliega otra versión distinta
export function dismissUpdate() {
  versionState.dismissedVersion = versionState.serverVersion;
  versionState.updateAvailable = false;
}

export function startVersionWatcher({
  intervalMs = CHECK_INTERVAL_MS,
  doc = document,
  enabled = process.env.NODE_ENV === "production",
} = {}) {
  if (!enabled || !currentVersion()) return () => {};

  const check = () => {
    if (doc.visibilityState === "visible") checkForNewVersion();
  };
  doc.addEventListener("visibilitychange", check);
  const timer = setInterval(check, intervalMs);

  return () => {
    doc.removeEventListener("visibilitychange", check);
    clearInterval(timer);
  };
}
